import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import readConfig from '../utils/readClientConfiguration';
import productionConfiguration from '../config/default.json';

const Media = () => {
    const cdnUrl = readConfig(productionConfiguration, 'cdn');
    const location = useLocation();
    const currentPath = location.pathname;

    const modifiedPath = cdnUrl + currentPath.replace('/image', '');

    return <Navigate to={modifiedPath} replace={false} />;
};

export default Media;